module.exports = __webpack_public_path__ + "1457db0e39304f2dfe3baa842cc65a15.jpeg";